/* CREU — Rejilla de Combinaciones / Lookbook (sections/creu-combinaciones-grid).
 *
 * · Vista grande / media / pequeña: cambia `data-vista` de la rejilla y se
 *   recuerda en el navegador.
 * · Vista inspo: al pulsar una foto se abre a pantalla completa (un <dialog>
 *   nativo: Escape, foco atrapado y fondo inerte de serie) con flechas para
 *   pasar de combinación. El "+" pide las piezas a la sección creu-pack-inspo
 *   y las prepara con CreuPack (assets/creu-pack-pieces.js).
 * · Scroll continuo (21-10-2026): al acercarse al final de la rejilla se pide
 *   la página siguiente a la propia sección y sus fotos se añaden debajo. El
 *   enlace "Siguiente" se oculta; si la carga falla, vuelve a aparecer.
 * Sin JS cada foto es un enlace normal a la ficha del pack y queda la paginación. */
(function () {
  if (window.__creuCombi) return;
  window.__creuCombi = true;

  // Textos de window.CreuT (layout); el literal es el fallback en español.
  var tr = function (k, fallback) { return (window.CreuT && window.CreuT[k]) || fallback; };

  var CLAVE_VISTA = 'creu:combi-vista';
  var VISTAS = ['grande', 'media', 'pequena'];

  function pintarVista(raiz, vista) {
    var grid = raiz.querySelector('[data-combi-grid]');
    if (grid) grid.setAttribute('data-vista', vista);
    raiz.querySelectorAll('[data-combi-vista]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-combi-vista') === vista ? 'true' : 'false');
    });
  }

  function numPagina(href) {
    try {
      return parseInt(new URL(href, location.href).searchParams.get('page') || '1', 10) || 1;
    } catch (e) {
      return 1;
    }
  }

  function enlaceSiguiente(raizODoc) {
    var actual = numPagina(location.href);
    var nav = raizODoc.querySelector('.creu-combi__pages');
    if (!nav) return null;
    var links = nav.querySelectorAll('a[href]');
    var mejor = null;
    for (var i = 0; i < links.length; i++) {
      if (numPagina(links[i].getAttribute('href')) > actual) mejor = links[i];
    }
    return mejor;
  }

  function iniciar(raiz) {
    if (raiz._combi) return;
    var dialog = raiz.querySelector('[data-combi-dialog]');
    var tiles = Array.prototype.slice.call(raiz.querySelectorAll('[data-combi-open]'));
    var st = { i: 0, origen: null, cache: {}, ctrl: null };
    raiz._combi = st;

    var guardada = null;
    try { guardada = localStorage.getItem(CLAVE_VISTA); } catch (e) { /* sin almacenamiento */ }
    if (VISTAS.indexOf(guardada) >= 0) pintarVista(raiz, guardada);

    var img = dialog.querySelector('[data-combi-img]');
    var panel = dialog.querySelector('[data-combi-panel]');
    var plus = dialog.querySelector('[data-combi-plus]');
    var titulo = dialog.querySelector('[data-combi-title]');
    var piezas = dialog.querySelector('[data-combi-pieces]');

    function cerrarPanel() {
      panel.hidden = true;
      plus.setAttribute('aria-expanded', 'false');
    }

    function mostrar(i) {
      st.i = (i + tiles.length) % tiles.length;
      var t = tiles[st.i];
      img.src = t.getAttribute('data-img') || '';
      img.alt = t.getAttribute('data-title') || '';
      titulo.textContent = t.getAttribute('data-title') || '';
      var abierto = !panel.hidden;
      cerrarPanel();
      if (abierto) abrirPanel();
    }

    async function abrirPanel() {
      var t = tiles[st.i];
      var handle = t.getAttribute('data-handle');
      panel.hidden = false;
      plus.setAttribute('aria-expanded', 'true');
      if (st.cache[handle]) {
        piezas.replaceChildren(st.cache[handle]);
        return;
      }
      if (st.ctrl) st.ctrl.abort();
      var ctrl = (st.ctrl = new AbortController());
      piezas.textContent = tr('creu.packs.loading', 'Cargando…');
      try {
        var r = await fetch(t.getAttribute('href') + '?section_id=creu-pack-inspo', { signal: ctrl.signal });
        if (!r.ok) throw new Error('http_' + r.status);
        var doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        var nodo = doc.querySelector('[data-creu-pack]');
        if (ctrl.signal.aborted || tiles[st.i] !== t) return;
        if (!nodo) {
          piezas.textContent = tr('creu.packs.no_pieces_yet', 'Esta combinación todavía no tiene joyas asignadas.');
          return;
        }
        nodo = document.importNode(nodo, true);
        st.cache[handle] = nodo;
        piezas.replaceChildren(nodo);
        if (window.CreuPack) window.CreuPack.init(piezas);
      } catch (e) {
        if (e.name === 'AbortError') return;
        piezas.textContent = tr('creu.packs.pieces_load_error', 'No se han podido cargar las joyas.') + ' ';
        var a = document.createElement('a');
        a.href = t.getAttribute('href');
        a.textContent = tr('creu.packs.view_set', 'Ver la combinación');
        piezas.appendChild(a);
      }
    }

    raiz.addEventListener('click', function (e) {
      var vista = e.target.closest('[data-combi-vista]');
      if (vista) {
        var v = vista.getAttribute('data-combi-vista');
        pintarVista(raiz, v);
        try { localStorage.setItem(CLAVE_VISTA, v); } catch (err) { /* no persiste */ }
        return;
      }
      var tile = e.target.closest('[data-combi-open]');
      if (tile && tiles.length && typeof dialog.showModal === 'function') {
        e.preventDefault();
        st.origen = tile;
        mostrar(tiles.indexOf(tile));
        dialog.showModal();
        return;
      }
      if (e.target.closest('[data-combi-prev]')) return mostrar(st.i - 1);
      if (e.target.closest('[data-combi-next]')) return mostrar(st.i + 1);
      if (e.target.closest('[data-combi-plus]')) {
        if (panel.hidden) abrirPanel();
        else cerrarPanel();
        return;
      }
      if (e.target.closest('[data-combi-hide]')) {
        cerrarPanel();
        plus.focus();
        return;
      }
      if (e.target.closest('[data-combi-close]')) dialog.close();
    });

    dialog.addEventListener('keydown', function (e) {
      if (e.target.closest('input, textarea, select')) return;
      if (e.key === 'ArrowLeft') mostrar(st.i - 1);
      else if (e.key === 'ArrowRight') mostrar(st.i + 1);
    });

    // Al cerrar (botón, Escape) el foco vuelve a la foto que se abrió.
    dialog.addEventListener('close', function () {
      if (st.ctrl) st.ctrl.abort();
      if (st.origen) st.origen.focus();
    });

    // Scroll continuo.
    var grid = raiz.querySelector('[data-combi-grid]');
    var mas = enlaceSiguiente(raiz);
    if (!grid || !mas || !('IntersectionObserver' in window)) return;
    var shell = raiz.closest('.shopify-section');
    var seccion = shell && shell.id ? shell.id.replace(/^shopify-section-/, '') : '';
    var cargando = false;
    var centinela = document.createElement('div');
    centinela.setAttribute('aria-hidden', 'true');
    centinela.style.height = '1px';
    grid.after(centinela);
    mas.hidden = true;

    var obs = new IntersectionObserver(function (entradas) {
      if (entradas[0].isIntersecting) cargar();
    }, { rootMargin: '0px 0px 1200px 0px' });
    obs.observe(centinela);

    function cerca() {
      return centinela.getBoundingClientRect().top < window.innerHeight + 1200;
    }

    function cargar() {
      if (cargando || !mas) return;
      cargando = true;
      var url = new URL(mas.getAttribute('href'), location.href);
      if (seccion) url.searchParams.set('section_id', seccion);
      fetch(url.toString())
        .then(function (r) {
          if (!r.ok) throw new Error('http_' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevos = doc.querySelectorAll('[data-combi-grid] > li');
          var frag = document.createDocumentFragment();
          for (var i = 0; i < nuevos.length; i++) frag.appendChild(document.importNode(nuevos[i], true));
          grid.appendChild(frag);
          tiles = Array.prototype.slice.call(raiz.querySelectorAll('[data-combi-open]'));
          var sig = null;
          var navNueva = doc.querySelector('.creu-combi__pages');
          if (navNueva) {
            var actual = numPagina(url.toString());
            navNueva.querySelectorAll('a[href]').forEach(function (a) {
              if (numPagina(a.getAttribute('href')) > actual) sig = a;
            });
          }
          if (sig) {
            mas.setAttribute('href', sig.getAttribute('href'));
            cargando = false;
            if (cerca()) cargar();
          } else {
            mas.remove();
            mas = null;
            obs.disconnect();
            centinela.remove();
          }
        })
        .catch(function () {
          // Si falla, se para el scroll y vuelve el enlace a la página siguiente.
          obs.disconnect();
          if (mas) mas.hidden = false;
        });
    }
  }

  function todo() {
    document.querySelectorAll('[data-creu-combi]').forEach(iniciar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo);
  else todo();
})();
